import { useEffect } from "react";
import { getLinkStore, getStore } from "../../utils/platform";
import "./style.css";
import { isAndroidWebView, isIOSWebView } from "../../global-components/src/utils/platform";
import { useAuth } from "../../global-components/src";

interface Props {
    setIsOpen: (val: boolean) => void
    isOpen: boolean
}

export default function RateApp({ setIsOpen, isOpen }: Props){
    const { isAuthenticated, user } = useAuth();
    const oneWeekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
    const createdAtTime = user?.created_at ? new Date(user.created_at).getTime() : new Date().getTime();

    const hide = () => {
        setIsOpen(false);
        localStorage.setItem("rateAppOpen", String(true));
    }

    useEffect(() => {
        if(!localStorage.getItem("rateAppOpen") && (isAndroidWebView() || isIOSWebView())){
            setIsOpen(true);
        }
    }, []);

    if(!isOpen || !isAuthenticated || createdAtTime < oneWeekAgo ) return null;

    return (
        <>  
            <div className="bg-modal" onClick={hide} />
            <div className="container-new-version">
                <div className="content-new-version">
                    <h1>Avaliar Paçoca</h1>
                    <p>Está gostando do app? Avaliar na { getStore() } ajuda muito ⭐</p>

                    <a onClick={hide} href={getLinkStore()} target="_blank" className="btn btn-blue btn-w-100  mt-3">
                        Avaliar
                    </a>

                    <div onClick={hide} style={{ width: "100%" }} className="w-100 text-center mt-3 link cursor-pointer">Já avaliei</div>
                </div>
            </div>
        </>
    );
}